import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    GetAllCollectionPoints,
    getAllOperationEntitiesForDropDown,
    getGroupByCollectionCatagoryID,
    getOperationentityCollectionCatagoryFilterData,
    AddOperationentityCollectionCatagory,
    getAvialableProducts,
    getUnsusedProducts,
    EditOperationentityCollectionCatagory,
    GetUnassignedCollectionCategoryByOperationentity
};

async function getOperationentityCollectionCatagoryFilterData(data) {
    var filterModel = {
        operationEntityID: data.operationEntityID,
        productID: data.productID,
        collectionCatagoryID: ""
    }
    const response = await CommonPost('/api/OpearationentityCollectionCatagoryMapping/FilterOpearationentityCollectionCatagory', null, filterModel);
    return response.data;
}

async function AddOperationentityCollectionCatagory(data) {
    let collectionCatagory = {
        collectionCategoryID: 0,
        operationEntityID: parseInt(data.operationEntityID),
        productID:  parseInt(data.productID),
        collectionCategoryMasterID:  parseInt(data.collectionCategoryMasterID),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }
    var response = await CommonPost('/api/OpearationentityCollectionCatagoryMapping/AddOpearationentityCollectionCatagory', null, collectionCatagory);
    return response;
}

async function EditOperationentityCollectionCatagory(collectionCategoryID) {
    var response = await CommonGet('/api/OpearationentityCollectionCatagoryMapping/UpdateOpearationentityCollectionCatagory','collectionCategoryID=' + collectionCategoryID);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1] !== undefined && item[1]["operationEntityID"] === id && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getGroupByCollectionCatagoryID(collectionCatagoryID) {
    var response = await CommonGet('/api/OpearationentityCollectionCatagoryMapping/GetGroupByCollectionCatagory', 'ID=' + collectionCatagoryID);
    return response.data;
}

async function getAvialableProducts(operationEntityID){
    var productsArray = [];
    var response = await CommonGet('/api/Product/GetProductsOfOperationEntity','operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["productID"]] = item[1]["productName"];
    }
    return productsArray;
}

async function getUnsusedProducts(operationEntityID){
    var productsArray = [];
    var response = await CommonGet('/api/Product/GetUnusedProductsOfOperationEntity','operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
            productsArray[item[1]["productID"]] = item[1]["productName"];
    }
    return productsArray;
}

async function GetUnassignedCollectionCategoryByOperationentity(data){
    var filterModel = {
        operationEntityID: data.operationEntityID.toString(),
        productID: data.productID.toString(),
        collectionCategoryMasterID: data.collectionCategoryMasterID.toString()
    } 
    var productsArray = [];
    var response = await CommonPost('/api/OpearationentityCollectionCatagoryMapping/GetUnassignedCollectionCategoryByOperationentity', null, filterModel);
    for (let item of Object.entries(response.data)) {
        productsArray[item[1]["collectionCategoryMasterID"]] = item[1]["collectionCategoryName"];
    }
    return productsArray;
}